// extracted by mini-css-extract-plugin
export default {"loadContainer":"LoadProvider_loadContainer__qHOdO","dotsCss":"LoadProvider_dotsCss__XN9a-","dot":"LoadProvider_dot__9UO09","bounce":"LoadProvider_bounce__svpOl"};